// extracted by mini-css-extract-plugin
module.exports = {"getStartedBottom":"getStarted-module--getStartedBottom--1Bv0W","getStartedBottomTitle":"getStarted-module--getStartedBottomTitle--1D29A"};